<template lang="pug">
.market-prices
  template(v-if="!isEmpty(competitors)")
    .row
      .number
        .number__row.number__row--months(:style="gridTemplateStyle")
          .number__row-first
          span(v-for="item in numbers") {{ `${item} 万` }}
    .gantt-body(:style="marketPriceHeightStyle")
      .row.market-price(v-for="array in groupByNumber")
        .gantt
          .gantt__row.gantt__row--lines(:style="gridTemplateStyle")
            span(v-for="index in numbers")
          .gantt__row
            .gantt__row-first
              span.property-name {{ array[0].property_name }}
          .gantt__row(v-for="(ar, key) in groupLayoutArray(array)")
            .gantt__row-first {{key}}
              span.label ({{ar.length}})
            ul.gantt__row-bars(:style="barsStyle")
              li(:style="style(ar)")
                .gantt__row-bars__label
                  span {{ minMaxRentString(ar) }}
                  br
                  span {{ basicUnitPriceString(ar) }}
  template(v-else)
    .row.d-flex.justify-content-center.no-competitors
      p {{ $t('competitors_page.no_competitors') }}
</template>

<script>
import { groupBy, range, map, isEmpty } from 'lodash'
export default {
  props: {
    competitors: {
      type: Array,
      default() {
        return {}
      }
    },
    room: {
      type: Object,
      default() {
        return {}
      }
    },
    marketPriceHeight: {
      type: String,
      default: '500px'
    }
  },
  computed: {
    monthMoneyArray() {
      return map(this.competitors, 'month_money')
    },

    min() {
      return parseInt(Math.min(...this.monthMoneyArray) / 10000)
    },

    max() {
      return parseInt(Math.max(...this.monthMoneyArray) / 10000)
    },

    numbers() {
      return range(this.min-1, this.max+4)
    },

    barsStyle() {
      return `
        grid-template-columns: repeat(${this.max + 4}, 1fr);
      `
    },

    gridTemplateStyle() {
      return `
        grid-template-columns: 200px repeat(${this.max + 4}, 1fr);
      `
    },

    groupByNumber() {
      return groupBy(this.competitors, 'number')
    },

    marketPriceHeightStyle() {
      return `height: ${this.marketPriceHeight};`
    }
  },
  methods: {
    isEmpty,

    groupLayoutArray(array) {
      return groupBy(array, 'layout')
    },

    style(array) {
      let minMax = this.minMaxRent(array)
      let background = { 'background-image': 'linear-gradient(270deg, rgba(24,172,235,0.98) 0%, #18A4EB 100%)' }

      return {
        ...background,
        'grid-column-start': this.getNumberColumn(minMax.min) + 1,
        'grid-column-end': this.getNumberColumn(minMax.max) + 1
      }
    },

    getNumberColumn(value) {
      return this.numbers.indexOf(parseInt(value / 10000))
    },

    getPropertyName(array) {
      return array[0].property_name
    },

    minMaxRent(array) {
      let minMax = {}
      let numbersArray = map(array, 'month_money')

      minMax.min = Math.min(...numbersArray)
      minMax.max = Math.max(...numbersArray)

      return minMax
    },

    minMaxBasicUnitPrice(array) {
      let minMax = {}
      let numbersArray = map(array, 'basic_unit_price')

      minMax.min = Math.min(...numbersArray)
      minMax.max = Math.max(...numbersArray)

      return minMax
    },

    minMaxRentString(array) {
      let minMax = this.minMaxRent(array)

      return `賃料: ${this.$n(minMax.min)}~${this.$n(minMax.max)} 円`
    },

    basicUnitPriceString(array) {
      let minMax = this.minMaxBasicUnitPrice(array)

      return `坪単価: ${this.$n(minMax.min)}~${this.$n(minMax.max)} 円`
    }
  }
}
</script>

<style lang="scss" scoped>
/* stylelint-disable no-descending-specificity, selector-pseudo-element-colon-notation  */
.market-prices {
  .gantt-body {
    height: 500px;
    overflow-x: auto;
    overflow-y: auto;
  }

  .no-competitors {
    font-size: 14px;
    margin-top: 20px;
  }

  .label {
    color: #7c91a7;
    font-size: 13px;
    font-weight: 300;
    margin-left: 4px;
  }

  .property-name {
    color: #008bd0;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    margin-left: 10px;
  }

  .number {
    border: 0;
    border-radius: 12px;
    display: grid;
    overflow: hidden;
    position: relative;
    width: 100%;

    &__row {
      display: grid;
      grid-template-columns: 200px 1fr;

      .number__row-first {
        border-top: 0;
      }

      &-first {
        border-color: rgba(0, 0, 0, 0.1);
        border-style: solid;
        border-width: 1px 0 0 0;
        font-size: 13px;
        font-weight: 500;
        padding: 15px 0;
        text-align: center;
      }

      &--empty {
        background-color: lighten(#ff6252, 25%) !important;
        z-index: 1;

        .number__row-first {
          border-width: 1px 1px 0 0;
        }
      }

      &--months {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        color: #fff;

        .number__row-first {
          border-top: 0 !important;
        }

        span {
          align-self: center;
          color: #7c91a7;
          font-size: 14px;
          font-weight: 300;
          padding: 10px 0;
          text-align: left;
        }
      }
    }
  }

  .competitor__row {
    border-bottom: 1px solid red;
    margin-top: 10px;
    padding-bottom: 5px;
  }

  .gantt {
    border: 0;
    border-bottom: 1px solid #e7ecf4;
    border-radius: 12px;
    display: grid;
    overflow: hidden;
    position: relative;
    width: 100%;

    &__row {
      display: grid;
      grid-template-columns: 200px 1fr;

      .gantt__row-bars {
        border-top: 0;

        li {
          border-radius: 2px;
          height: 16px;
          margin-top: 7px;
        }
      }

      .gantt__row-first {
        border-right: 2px solid #e7ecf4;
        border-top: 0;
        position: relative;

        &:after {
          border-bottom: 1px solid #7c91a7;
          bottom: 0;
          content: ' ';
          position: absolute;
          right: -10px;
          top: 0;
          width: 9px;
        }
      }

      &--empty {
        background-color: lighten(#ff6252, 25%) !important;
        z-index: 1;

        .gantt__row-first {
          border-width: 1px 1px 0 0;
        }
      }

      &--lines {
        height: 100%;
        position: absolute;
        width: 100%;

        span {
          border-right: 2px dashed #e7ecf4;
          display: block;

          &:first-child {
            border-right: none;
          }

          &.marker {
            background-color: rgba(10, 52, 68, 0.13);
            z-index: 2;
          }
        }

        &:after {
          background-color: #1688b345;
          grid-column: 0;
          grid-row: 1;
          height: 100%;
          z-index: 2;
        }
      }

      &-first {
        border-color: rgba(0, 0, 0, 0.1);
        border-style: solid;
        border-width: 1px 0 0 0;
        font-size: 14px;
        font-weight: 500;
        padding: 15px 0;
        text-align: center;
      }

      &-bars {
        border-top: 1px solid rgba(221, 221, 221, 0.8);
        display: grid;
        grid-gap: 8px 0;
        list-style: none;
        margin: 0;
        padding: 9px 0;

        li {
          background-color: #55de84;
          border-radius: 20px;
          color: #fff;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          min-height: 15px;
          padding: 5px 12px;
          position: relative;
          text-align: left;

          .gantt__row-bars__label {
            color: #7c91a7;
            font-size: 13px;
            font-weight: 300;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%) translateX(calc(100% + 10px));
            width: 150px;
          }

          &.stripes {
            border: 1px solid #7c91a7;
            opacity: 0.3;
          }

          &:before,
          &:after {
            content: "";
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 4;
          }

          &:before {
            left: 0;
          }

          &:after {
            right: 0;
          }
        }
      }
    }
  }
}
/* stylelint-enable no-descending-specificity, selector-pseudo-element-colon-notation  */
</style>
